
import { CoachingDetails } from "@/components/coaches/CoachingDetails";
import { CoachesList } from "@/components/CoachesList";
import { Button } from "@/components/ui/button";
import { useNavigation } from "@/hooks/use-navigation";

const Coaches = () => {
  const navigate = useNavigation();

  return (
    <main className="min-h-screen bg-background">
      <CoachingDetails />
      
      <section className="py-12">
        <div className="container mx-auto">
          <CoachesList />
        </div>
      </section>
    </main>
  );
};

export default Coaches;
